export function Loading({ label = 'Lade...' }: { label?: string }) {
  return (
    <div className="text-[12px] text-neutral-600 py-2 px-2 italic">{label}</div>
  );
}

export function ErrorBox({ error }: { error: unknown }) {
  const msg = error instanceof Error ? error.message : String(error);
  return (
    <div className="border border-st-err bg-red-50 text-st-err px-2 py-1.5 text-[12px]">
      Fehler: {msg}
    </div>
  );
}

export function EmptyBox({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-[12px] text-neutral-500 italic px-2 py-2 border border-dashed border-neutral-300 bg-neutral-50">
      {children}
    </div>
  );
}
